export default __webpack_public_path__ + "static/media/close.d78f7db0.svg";